<div ng-controller="FormConfigController as vm" class="form-config-readonly-editor" readonly="true">
    <div class="editor">
        <h1>{{editor.stage.Name|localize}}</h1>
        <div c-state-chart workflow-config="vm.workflowConfig" on-state-clicked="onStateClicked(state)" selected="vm.selectedState"></div>
        <div c-form-config-editor></div>
    </div>
</div>
